import { formatUploadFileSize, readFileAsDataUrl } from './file-upload-utils'

export const RASPADINHA_PDF_ACCEPT = 'application/pdf'

export const RASPADINHA_MAX_PDF_BYTES = 10 * 1024 * 1024

export function validateRaspadinhaPdfFile(
  file: File,
  label: string,
  maxBytes = RASPADINHA_MAX_PDF_BYTES
): string | null {
  if (file.type !== 'application/pdf') {
    return `${label} deve ser um arquivo PDF.`
  }
  if (file.size > maxBytes) {
    return `${label} excede o limite de ${formatUploadFileSize(maxBytes)}. Arquivo selecionado: ${formatUploadFileSize(file.size)}.`
  }
  return null
}

export function readPdfFileAsDataUrl(file: File): Promise<string> {
  return readFileAsDataUrl(file)
}

export function formatRaspadinhaPdfFileSize(bytes: number): string {
  return formatUploadFileSize(bytes)
}
